/* ==========================================================================
   Banyo Yedek Parça — global tema scripti
   Framework yok, build yok. Tek global: window.Theme.
   Stateful UI parçaları Custom Element olarak tanımlanır.
   ========================================================================== */
(function () {
  'use strict';

  /* ----- Çekirdek yardımcılar ----- */
  const Theme = window.Theme || {};

  Theme.routes = window.routes || {};

  Theme.debounce = function (fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  Theme.fetchConfig = function (type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  };

  // Basit pub/sub
  const subscribers = {};
  Theme.on = function (event, cb) {
    (subscribers[event] = subscribers[event] || []).push(cb);
    return () => {
      subscribers[event] = (subscribers[event] || []).filter((c) => c !== cb);
    };
  };
  Theme.emit = function (event, payload) {
    (subscribers[event] || []).forEach((cb) => cb(payload));
  };

  // Odak tuzağı (drawer/menü için)
  Theme.trapFocus = function (container, elementToFocus = container) {
    // Idempotent: önceki handler varsa kaldır (çift açılışta listener sızıntısını önler)
    if (container.__trapHandler) {
      document.removeEventListener('keydown', container.__trapHandler);
      container.__trapHandler = null;
    }
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last && last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first && first.focus();
      }
    }
    container.__trapHandler = handler;
    document.addEventListener('keydown', handler);
    (elementToFocus || container).focus();
  };
  Theme.removeTrapFocus = function (container, elementToFocus) {
    if (container && container.__trapHandler) {
      document.removeEventListener('keydown', container.__trapHandler);
      container.__trapHandler = null;
    }
    if (elementToFocus) elementToFocus.focus();
  };

  /* ----- Duyuru çubuğu kapatma (localStorage) ----- */
  function initAnnouncementDismiss() {
    document.querySelectorAll('[data-announcement-dismiss]').forEach((btn) => {
      const bar = btn.closest('[data-announcement]');
      if (!bar) return;
      const key = 'announcement-dismissed-' + (bar.dataset.announcement || 'default');
      if (localStorage.getItem(key) === '1') {
        bar.hidden = true;
        return;
      }
      btn.addEventListener('click', () => {
        bar.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    });
  }

  /* ----- Duyuru çubuğu dönüşümü (kayan mesajlar) ----- */
  function initAnnouncementRotator() {
    document.querySelectorAll('[data-announcement-rotate]').forEach((bar) => {
      const slides = bar.querySelectorAll('[data-announcement-slide]');
      if (slides.length < 2) return;
      const speed = (parseInt(bar.dataset.announcementSpeed, 10) || 4) * 1000;
      let i = 0;
      setInterval(() => {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ----- Genel drawer/menü toggle ----- */
  // <button data-drawer-toggle="DRAWER_ID"> ... <div id="DRAWER_ID" data-drawer>
  function initDrawers() {
    document.querySelectorAll('[data-drawer-toggle]').forEach((toggle) => {
      const id = toggle.getAttribute('data-drawer-toggle');
      const drawer = document.getElementById(id);
      if (!drawer) return;

      const open = () => setDrawer(drawer, toggle, true);
      const close = () => setDrawer(drawer, toggle, false);

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = drawer.classList.contains('is-open');
        isOpen ? close() : open();
      });

      drawer.querySelectorAll('[data-drawer-close]').forEach((c) =>
        c.addEventListener('click', close)
      );
      drawer.addEventListener('click', (e) => {
        if (e.target === drawer || e.target.hasAttribute('data-drawer-overlay')) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  function setDrawer(drawer, toggle, open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('overflow-hidden', open);
    if (open) {
      Theme.trapFocus(drawer);
    } else {
      Theme.removeTrapFocus(drawer, toggle);
    }
    Theme.emit('drawer:toggle', { drawer, open });
  }

  /* ----- AJAX Sepet denetleyicisi (Blok 2'de genişletilir) ----- */
  Theme.cart = {
    async add(items, sections) {
      const body = { items: Array.isArray(items) ? items : [items] };
      if (sections) body.sections = sections;
      const res = await fetch(`${Theme.routes.cart_add_url || '/cart/add'}.js`, {
        ...Theme.fetchConfig(),
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw data;
      Theme.emit('cart:updated', data);
      return data;
    },
    async get() {
      const res = await fetch(`${Theme.routes.cart_url || '/cart'}.js`);
      return res.json();
    },
    async change(payload, sections) {
      const body = { ...payload };
      if (sections) body.sections = sections;
      const res = await fetch(`${Theme.routes.cart_change_url || '/cart/change'}.js`, {
        ...Theme.fetchConfig(),
        body: JSON.stringify(body),
      });
      const data = await res.json();
      Theme.emit('cart:updated', data);
      return data;
    },
  };

  // Para birimi formatı (cart.js fiyatları kuruş cinsinden)
  Theme.money = function (cents) {
    const num = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.shopCurrency || 'TRY' }).format(num);
    } catch (e) {
      return num.toFixed(2);
    }
  };

  /* ----- İkon SVG yardımcıları (icon.liquid ile birebir eşleşir) ----- */
  Theme.iconPaths = {
    trash: '<path d="M4 7h16" stroke-linecap="round"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 7l1 12a1.5 1.5 0 0 0 1.5 1.4h7A1.5 1.5 0 0 0 17 19L18 7" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 11v6M14 11v6" stroke-linecap="round"/>',
    heart: '<path d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z" stroke-linejoin="round"/>',
    cart: '<path d="M3 4h2l2.4 12.2a1 1 0 0 0 1 .8h8.2a1 1 0 0 0 1-.8L20 8H6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.4" class="icon--filled"/><circle cx="18" cy="20" r="1.4" class="icon--filled"/>'
  };
  Theme.iconSvg = function (name, size) {
    const s = size || 16;
    return '<svg class="icon icon--' + name + '" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' + (Theme.iconPaths[name] || '') + '</svg>';
  };

  /* ----- Favoriler (localStorage tabanlı wishlist) ----- */
  Theme.favorites = (function () {
    const KEY = 'bp_favorites';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      Theme.emit('favorites:updated', list);
    }
    return {
      list: read,
      count() { return read().length; },
      has(handle) { return read().some((f) => f.handle === handle); },
      add(item) {
        if (!item || !item.handle) return read();
        const list = read();
        if (!list.some((f) => f.handle === item.handle)) {
          list.unshift(item);
          write(list);
        }
        return list;
      },
      remove(handle) {
        const list = read().filter((f) => f.handle !== handle);
        write(list);
        return list;
      },
      toggle(item) {
        return this.has(item.handle) ? this.remove(item.handle) : this.add(item);
      }
    };
  })();

  /* ----- Karşılaştırma (localStorage tabanlı, favorites ile aynı desen) ----- */
  Theme.compare = (function () {
    const KEY = 'bp_compare';
    const MAX = 4;
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      Theme.emit('compare:updated', list);
    }
    return {
      max: MAX,
      list: read,
      count() { return read().length; },
      has(handle) { return read().some((f) => f.handle === handle); },
      isFull() { return read().length >= MAX; },
      add(item) {
        if (!item || !item.handle) return read();
        const list = read();
        if (list.some((f) => f.handle === item.handle)) return list;
        if (list.length >= MAX) return list; // dolu → ekleme
        list.push(item);
        write(list);
        return list;
      },
      remove(handle) {
        const list = read().filter((f) => f.handle !== handle);
        write(list);
        return list;
      },
      clear() { write([]); },
      toggle(item) {
        return this.has(item.handle) ? this.remove(item.handle) : this.add(item);
      }
    };
  })();

  /* ----- Toast bildirimi (Geri Al eylemi destekli) ----- */
  Theme.toast = function (message, opts) {
    opts = opts || {};
    let stack = document.querySelector('.toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'toast-stack';
      stack.setAttribute('role', 'status');
      stack.setAttribute('aria-live', 'polite');
      document.body.appendChild(stack);
    }
    const toast = document.createElement('div');
    toast.className = 'toast';
    const msg = document.createElement('span');
    msg.className = 'toast__msg';
    msg.textContent = message;
    toast.appendChild(msg);

    let timer;
    const dismiss = () => {
      clearTimeout(timer);
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 260);
    };
    if (opts.actionLabel && typeof opts.onAction === 'function') {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'toast__action';
      btn.textContent = opts.actionLabel;
      btn.addEventListener('click', () => { opts.onAction(); dismiss(); });
      toast.appendChild(btn);
    }
    stack.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    timer = setTimeout(dismiss, opts.duration || 5000);
    return toast;
  };

  // Sepet çekmecesini cart.js verisiyle güncelle
  Theme.renderCart = function (cart) {
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = Theme.money(cart.total_price);
    });
    const sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = Theme.money(cart.total_price);

    const list = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    if (list) {
      if (cart.item_count === 0) {
        list.innerHTML = '<p class="cart-drawer__empty">' + (window.cartStrings && window.cartStrings.empty || 'Sepetiniz boş.') + '</p>';
        if (footer) footer.hidden = true;
      } else {
        const strings = window.cartStrings || {};
        const removeLabel = strings.remove || 'Kaldır';
        const favLabel = strings.move_to_favorites || 'Favorilere taşı';
        const esc = (s) => String(s == null ? '' : s).replace(/"/g, '&quot;');
        let html = '<ul class="cart-drawer__list">';
        cart.items.forEach((item) => {
          const img = item.image ? '<img class="cart-line__img" src="' + item.image + '" alt="" width="60" height="60" loading="lazy">' : '';
          const key = item.key || '';
          const favBtn =
            '<button type="button" class="cart-line__fav" data-cart-move-fav' +
            ' data-key="' + esc(key) + '"' +
            ' data-fav-handle="' + esc(item.handle) + '"' +
            ' data-fav-id="' + esc(item.variant_id || item.id) + '"' +
            ' data-fav-title="' + esc(item.product_title) + '"' +
            ' data-fav-url="' + esc(item.url) + '"' +
            ' data-fav-image="' + esc(item.image || '') + '"' +
            ' data-fav-price="' + esc(item.final_price) + '">' +
            Theme.iconSvg('heart', 14) + '<span>' + favLabel + '</span></button>';
          html +=
            '<li class="cart-line" data-cart-line data-key="' + esc(key) + '">' + img +
            '<div class="cart-line__info"><a href="' + item.url + '" class="cart-line__title">' + item.product_title +
            '</a><span class="cart-line__meta">' + item.quantity + ' × ' + Theme.money(item.final_price) + '</span>' + favBtn + '</div>' +
            '<button type="button" class="cart-line__remove" data-cart-remove data-key="' + esc(key) + '" aria-label="' + removeLabel + '" title="' + removeLabel + '">' +
            Theme.iconSvg('trash', 17) +
            '</button></li>';
        });
        html += '</ul>';
        list.innerHTML = html;
        if (footer) footer.hidden = false;
      }
    }
  };

  // AJAX sepete ekleme formları
  function initCartForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-cart-form]');
      if (!form) return;
      e.preventDefault();
      const button = form.querySelector('[data-add-button]');
      if (button) button.classList.add('is-loading');

      try {
        const formData = new FormData(form);
        const items = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
        await Theme.cart.add(items);
        const cart = await Theme.cart.get();
        Theme.renderCart(cart);
        updateFreeShipping(cart.total_price);
        // Sepet çekmecesini aç (ortak setDrawer ile: aria-expanded + focus tutarlı)
        const drawer = document.getElementById('CartDrawer');
        if (drawer) {
          const toggle = document.querySelector('[data-drawer-toggle="CartDrawer"]');
          setDrawer(drawer, toggle, true);
        }
      } catch (err) {
        console.error('Sepete eklenemedi', err);
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    });

    // "Hemen Al" — sepete ekle + SEPETE git.
    // NOT: Doğrudan /checkout'a gitmek, mesafeli satış sözleşmesi onayını ve
    // fatura bilgisi (TC/vergi no) alanlarını atlıyordu. Yasal onay ve fatura
    // verisi sepet sayfasında toplandığı için kullanıcı oraya yönlendirilir.
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-buy-now]');
      if (!btn) return;
      e.preventDefault();
      const form = btn.closest('[data-cart-form]');
      if (!form) return;
      btn.classList.add('is-loading');
      try {
        const formData = new FormData(form);
        const items = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
        await Theme.cart.add(items);
        window.location.href = '/cart';
      } catch (err) {
        console.error('Hemen al başarısız', err);
        btn.classList.remove('is-loading');
      }
    });
  }

  /* ----- Sepet sayfası: AJAX adet + ücretsiz kargo çubuğu ----- */
  function updateFreeShipping(totalPrice) {
    const box = document.querySelector('[data-freeship]');
    if (!box) return;
    const threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;
    if (threshold <= 0) return;
    const fill = box.querySelector('[data-freeship-fill]');
    const text = box.querySelector('[data-freeship-text]');
    const pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (text) {
      const strings = window.cartStrings || {};
      const iconEl = text.querySelector('.icon');
      const icon = iconEl ? iconEl.outerHTML : '';
      if (totalPrice >= threshold) {
        text.innerHTML = icon + ' ' + (strings.free_shipping_eligible || 'Ücretsiz kargo kazandınız.');
      } else {
        const remaining = Theme.money(threshold - totalPrice);
        const tpl = strings.free_shipping_remaining || '{{ amount }} kaldı';
        text.innerHTML = icon + ' ' + tpl.replace('__AMT__', remaining).replace('{{ amount }}', remaining);
      }
    }
  }

  function updateQtyHref(btn, quantity) {
    const href = btn.getAttribute('href') || '';
    return href.replace(/quantity=\d+/, 'quantity=' + Math.max(0, quantity));
  }

  function initCartPage() {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      e.preventDefault();
      const row = btn.closest('[data-cart-line]');
      if (!row) return;
      const key = row.getAttribute('data-key');
      const quantity = parseInt(btn.getAttribute('data-quantity'), 10);
      if (isNaN(quantity) || quantity < 0) return;
      row.classList.add('is-loading');
      try {
        const cart = await Theme.cart.change({ id: key, quantity });
        const item = cart.items.find((it) => it.key === key);
        if (!item) {
          row.remove();
          if (cart.item_count === 0) { window.location.reload(); return; }
        } else {
          const qval = row.querySelector('[data-qty-val]');
          if (qval) qval.textContent = item.quantity;
          const total = row.querySelector('[data-line-total]');
          if (total) total.textContent = Theme.money(item.final_line_price);
          const steppers = row.querySelectorAll('.cart-row__change[data-cart-change]');
          if (steppers[0]) { steppers[0].setAttribute('data-quantity', item.quantity - 1); steppers[0].setAttribute('href', updateQtyHref(steppers[0], item.quantity - 1)); }
          if (steppers[1]) { steppers[1].setAttribute('data-quantity', item.quantity + 1); steppers[1].setAttribute('href', updateQtyHref(steppers[1], item.quantity + 1)); }
          // Adet 1'e düşünce eksi tuşu çöp kutusuna dönüşsün
          const qtyBox = row.querySelector('[data-qty]');
          if (qtyBox) {
            const atMin = item.quantity <= 1;
            qtyBox.classList.toggle('cart-row__qty--min', atMin);
            const dec = qtyBox.querySelector('.cart-row__change--dec');
            if (dec) dec.setAttribute('aria-label', atMin ? (window.cartStrings && window.cartStrings.remove || 'Kaldır') : 'Adedi azalt');
          }
        }
        const sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = Theme.money(cart.total_price);
        updateFreeShipping(cart.total_price);
        if (Theme.renderCart) Theme.renderCart(cart);
      } catch (err) {
        console.error('Sepet güncellenemedi', err);
        window.location.href = btn.getAttribute('href');
      } finally {
        row.classList.remove('is-loading');
      }
    });
  }

  /* ----- Sepet: satır kaldırma + favorilere taşıma (Geri Al destekli) ----- */
  function initCartActions() {
    document.addEventListener('click', async (e) => {
      const favBtn = e.target.closest('[data-cart-move-fav]');
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (!favBtn && !removeBtn) return;
      e.preventDefault();
      const btn = favBtn || removeBtn;
      const key = btn.getAttribute('data-key');
      if (!key) return;
      const row = btn.closest('[data-cart-line], .cart-row');
      const onCartPage = !!document.querySelector('[data-cart-page]');
      const strings = window.cartStrings || {};
      if (row) row.classList.add('is-loading');

      // Geri Al için kaldırılacak satırın bilgisini yakala
      let restore = null;
      try {
        const current = await Theme.cart.get();
        const line = (current.items || []).find((it) => it.key === key);
        if (line) restore = { id: line.variant_id || line.id, quantity: line.quantity, properties: line.properties };
      } catch (e2) {}

      // Favorilere taşı: önce favoriye ekle
      if (favBtn) {
        Theme.favorites.add({
          handle: favBtn.getAttribute('data-fav-handle'),
          id: favBtn.getAttribute('data-fav-id'),
          title: favBtn.getAttribute('data-fav-title'),
          url: favBtn.getAttribute('data-fav-url'),
          image: favBtn.getAttribute('data-fav-image'),
          price: parseInt(favBtn.getAttribute('data-fav-price'), 10) || 0
        });
      }

      try {
        const cart = await Theme.cart.change({ id: key, quantity: 0 });
        if (row && row.classList.contains('cart-row')) {
          row.remove();
          if (cart.item_count === 0) { window.location.reload(); return; }
          const sub = document.querySelector('[data-cart-subtotal]');
          if (sub) sub.textContent = Theme.money(cart.total_price);
        }
        if (Theme.renderCart) Theme.renderCart(cart);
        updateFreeShipping(cart.total_price);

        if (favBtn) {
          Theme.toast(strings.moved_to_favorites_toast || 'Ürün favorilere taşındı');
        } else if (restore) {
          Theme.toast(strings.removed_toast || 'Ürün kaldırıldı', {
            actionLabel: strings.undo || 'Geri Al',
            onAction: async () => {
              try {
                await Theme.cart.add({ id: restore.id, quantity: restore.quantity, properties: restore.properties });
                if (onCartPage) { window.location.reload(); return; }
                const fresh = await Theme.cart.get();
                if (Theme.renderCart) Theme.renderCart(fresh);
                updateFreeShipping(fresh.total_price);
              } catch (er) { console.error('Geri alınamadı', er); }
            }
          });
        }
      } catch (err) {
        console.error('Sepet işlemi başarısız', err);
        if (row) row.classList.remove('is-loading');
      }
    });
  }

  /* ----- Favoriler çekmecesi + rozet ----- */
  function renderFavoritesDrawer() {
    const listEl = document.querySelector('[data-favorites-list]');
    const emptyEl = document.querySelector('[data-favorites-empty]');
    if (!listEl || !emptyEl) return;
    const items = Theme.favorites.list();
    const fstr = window.favoritesStrings || {};
    if (!items.length) {
      listEl.hidden = true;
      listEl.innerHTML = '';
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    listEl.hidden = false;
    const esc = (s) => String(s == null ? '' : s).replace(/"/g, '&quot;');
    listEl.innerHTML = items.map((it) => {
      const img = it.image ? '<img class="favorites-line__img" src="' + esc(it.image) + '" alt="" width="60" height="60" loading="lazy">' : '';
      const price = it.price ? '<span class="favorites-line__price">' + Theme.money(it.price) + '</span>' : '';
      return '<li class="favorites-line" data-fav-line data-handle="' + esc(it.handle) + '">' + img +
        '<div class="favorites-line__info">' +
        '<a href="' + esc(it.url) + '" class="favorites-line__title">' + (it.title || '') + '</a>' + price +
        '<button type="button" class="favorites-line__add" data-fav-add data-id="' + esc(it.id) + '" data-handle="' + esc(it.handle) + '">' +
        Theme.iconSvg('cart', 15) + '<span>' + (fstr.add_to_cart || 'Sepete Ekle') + '</span></button>' +
        '</div>' +
        '<button type="button" class="favorites-line__remove" data-fav-remove data-handle="' + esc(it.handle) + '" aria-label="' + (fstr.remove || 'Kaldır') + '" title="' + (fstr.remove || 'Kaldır') + '">' +
        Theme.iconSvg('trash', 17) + '</button></li>';
    }).join('');
  }

  function updateFavCount() {
    const n = Theme.favorites.count();
    document.querySelectorAll('[data-fav-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // Kart/ürün sayfasındaki kalp butonlarının basılı (favoride) durumunu senkronla
  function syncFavToggles() {
    document.querySelectorAll('[data-fav-toggle]').forEach((btn) => {
      const handle = btn.getAttribute('data-fav-handle');
      const active = Theme.favorites.has(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const strings = window.themeStrings || {};
      btn.setAttribute('aria-label', active ? (strings.remove_from_favorites || 'Favorilerden çıkar') : (strings.add_to_favorites || 'Favorilere ekle'));
    });
  }

  function initFavorites() {
    updateFavCount();
    renderFavoritesDrawer();
    syncFavToggles();
    Theme.on('favorites:updated', () => { updateFavCount(); renderFavoritesDrawer(); syncFavToggles(); });
    // Çekmece açıldığında güncel listeyi göster
    Theme.on('drawer:toggle', (d) => {
      if (d && d.open && d.drawer && d.drawer.id === 'FavoritesDrawer') renderFavoritesDrawer();
    });

    document.addEventListener('click', async (e) => {
      const toggleBtn = e.target.closest('[data-fav-toggle]');
      const addBtn = e.target.closest('[data-fav-add]');
      const removeBtn = e.target.closest('[data-fav-remove]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        Theme.favorites.toggle({
          handle: toggleBtn.getAttribute('data-fav-handle'),
          id: toggleBtn.getAttribute('data-fav-id'),
          title: toggleBtn.getAttribute('data-fav-title'),
          url: toggleBtn.getAttribute('data-fav-url'),
          image: toggleBtn.getAttribute('data-fav-image'),
          price: parseInt(toggleBtn.getAttribute('data-fav-price'), 10) || 0
        });
        return;
      }
      if (addBtn) {
        e.preventDefault();
        const id = parseInt(addBtn.getAttribute('data-id'), 10);
        if (!id) return;
        addBtn.classList.add('is-loading');
        try {
          await Theme.cart.add({ id: id, quantity: 1 });
          Theme.favorites.remove(addBtn.getAttribute('data-handle'));
          const cart = await Theme.cart.get();
          if (Theme.renderCart) Theme.renderCart(cart);
          updateFreeShipping(cart.total_price);
          const drawer = document.getElementById('CartDrawer');
          if (drawer) setDrawer(drawer, document.querySelector('[data-drawer-toggle="CartDrawer"]'), true);
        } catch (err) {
          console.error('Sepete eklenemedi', err);
          addBtn.classList.remove('is-loading');
        }
      } else if (removeBtn) {
        e.preventDefault();
        Theme.favorites.remove(removeBtn.getAttribute('data-handle'));
      }
    });
  }

  /* ----- Ürün karşılaştırma (tepsi + modal) ----- */
  function initCompare() {
    const tray = document.querySelector('[data-compare-tray]');
    if (!tray && !document.querySelector('[data-compare-toggle]')) return;
    const cs = window.compareStrings || {};
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const modal = document.querySelector('[data-compare-modal]');
    let lastFocus = null;

    function readItem(btn) {
      return {
        handle: btn.getAttribute('data-compare-handle'),
        id: btn.getAttribute('data-compare-id'),
        title: btn.getAttribute('data-compare-title'),
        url: btn.getAttribute('data-compare-url'),
        image: btn.getAttribute('data-compare-image'),
        price: parseInt(btn.getAttribute('data-compare-price'), 10) || 0,
        compareAt: parseInt(btn.getAttribute('data-compare-compare-at'), 10) || 0,
        vendor: btn.getAttribute('data-compare-vendor') || '',
        oem: btn.getAttribute('data-compare-oem') || '',
        type: btn.getAttribute('data-compare-type') || '',
        sku: btn.getAttribute('data-compare-sku') || '',
        available: btn.getAttribute('data-compare-available') === 'true'
      };
    }

    function syncToggles() {
      document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
        const active = Theme.compare.has(btn.getAttribute('data-compare-handle'));
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function renderTray() {
      if (!tray) return;
      const items = Theme.compare.list();
      const itemsWrap = tray.querySelector('[data-compare-tray-items]');
      const countEl = tray.querySelector('[data-compare-count]');
      const openBtn = tray.querySelector('[data-compare-open]');
      if (!items.length) { tray.hidden = true; return; }
      tray.hidden = false;
      if (countEl) countEl.textContent = items.length;
      if (openBtn) openBtn.disabled = items.length < 2;
      if (itemsWrap) {
        itemsWrap.innerHTML = items.map((it) => {
          const img = it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '';
          return '<div class="compare-tray__item" title="' + esc(it.title) + '">' + img +
            '<button type="button" class="compare-tray__item-remove" data-compare-tray-remove data-handle="' + esc(it.handle) + '" aria-label="' + esc(cs.remove || 'Kaldır') + '">&times;</button></div>';
        }).join('');
      }
    }

    function buildTable() {
      const items = Theme.compare.list();
      const wrap = modal.querySelector('[data-compare-table]');
      if (!wrap) return;
      if (items.length < 1) { wrap.innerHTML = '<p style="padding:1.25rem">' + esc(cs.empty || '') + '</p>'; return; }
      const cols = (fn) => items.map(fn).join('');
      const priceCell = (it) => {
        // Teklif modu urunlerinde fiyat yok (0) — 0,00 TL yerine teklif metni
        if (!it.price) return '<span class="compare-table__price price__quote">' + esc(cs.quote_price || 'Fiyat icin teklif alin') + '</span>';
        let html = '<span class="compare-table__price">' + Theme.money(it.price) + '</span>';
        if (it.compareAt && it.compareAt > it.price) html = '<s>' + Theme.money(it.compareAt) + '</s> ' + html;
        return html;
      };
      const stockCell = (it) => it.available
        ? '<span class="stock--in">' + esc(cs.in_stock || 'Stokta Var') + '</span>'
        : '<span class="stock--out">' + esc(cs.out_of_stock || 'Stokta Yok') + '</span>';
      const addCell = (it) => it.available
        ? '<button type="button" class="btn btn--primary" data-compare-add data-id="' + esc(it.id) + '">' + esc(cs.add_to_cart || 'Sepete Ekle') + '</button>'
        : '<a class="btn btn--outline" href="' + esc(it.url) + '">' + esc(cs.view || 'İncele') + '</a>';
      wrap.innerHTML =
        '<table class="compare-table"><tbody>' +
        '<tr><th scope="row"></th>' + cols((it) => '<td>' + (it.image ? '<img class="compare-table__img" src="' + esc(it.image) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') +
          '<br><button type="button" class="compare-table__remove" data-compare-remove data-handle="' + esc(it.handle) + '">' + esc(cs.remove || 'Kaldır') + '</button></td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_product || 'Ürün') + '</th>' + cols((it) => '<td><a class="compare-table__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a></td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_brand || 'Marka') + '</th>' + cols((it) => '<td>' + (esc(it.vendor) || '—') + '</td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_oem || 'OEM') + '</th>' + cols((it) => '<td class="compare-table__oem">' + (esc(it.oem) || '—') + '</td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_type || 'Tür') + '</th>' + cols((it) => '<td>' + (esc(it.type) || '—') + '</td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_sku || 'Kod') + '</th>' + cols((it) => '<td class="compare-table__oem">' + (esc(it.sku) || '—') + '</td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_price || 'Fiyat') + '</th>' + cols((it) => '<td>' + priceCell(it) + '</td>') + '</tr>' +
        '<tr><th scope="row">' + esc(cs.col_stock || 'Durum') + '</th>' + cols((it) => '<td>' + stockCell(it) + '</td>') + '</tr>' +
        '<tr><th scope="row"></th>' + cols((it) => '<td>' + addCell(it) + '</td>') + '</tr>' +
        '</tbody></table>';
    }

    function openModal() {
      if (!modal || Theme.compare.count() < 1) return;
      buildTable();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
      const closeBtn = modal.querySelector('[data-compare-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    renderTray();
    syncToggles();
    Theme.on('compare:updated', () => { renderTray(); syncToggles(); if (modal && !modal.hidden) buildTable(); });

    document.addEventListener('click', async (e) => {
      const toggleBtn = e.target.closest('[data-compare-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = toggleBtn.getAttribute('data-compare-handle');
        if (!Theme.compare.has(handle) && Theme.compare.isFull()) {
          Theme.toast(cs.full || 'Karşılaştırma listesi dolu');
          return;
        }
        const added = !Theme.compare.has(handle);
        Theme.compare.toggle(readItem(toggleBtn));
        if (added) Theme.toast(cs.added || 'Karşılaştırmaya eklendi');
        return;
      }
      const trayRemove = e.target.closest('[data-compare-tray-remove]');
      if (trayRemove) { Theme.compare.remove(trayRemove.getAttribute('data-handle')); return; }
      const tblRemove = e.target.closest('[data-compare-remove]');
      if (tblRemove) { Theme.compare.remove(tblRemove.getAttribute('data-handle')); if (Theme.compare.count() < 1) closeModal(); return; }
      if (e.target.closest('[data-compare-open]')) { openModal(); return; }
      if (e.target.closest('[data-compare-clear]')) { Theme.compare.clear(); closeModal(); return; }
      if (e.target.closest('[data-compare-close]')) { closeModal(); return; }
      const addBtn = e.target.closest('[data-compare-add]');
      if (addBtn) {
        e.preventDefault();
        const id = parseInt(addBtn.getAttribute('data-id'), 10);
        if (!id) return;
        addBtn.classList.add('is-loading');
        try {
          await Theme.cart.add({ id: id, quantity: 1 });
          const cart = await Theme.cart.get();
          if (Theme.renderCart) Theme.renderCart(cart);
          updateFreeShipping(cart.total_price);
          closeModal();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) setDrawer(drawer, document.querySelector('[data-drawer-toggle="CartDrawer"]'), true);
        } catch (err) {
          console.error('Sepete eklenemedi', err);
          addBtn.classList.remove('is-loading');
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  /* ----- Hızlı önizleme (quick view) ----- */
  function initQuickView() {
    const modal = document.querySelector('[data-quickview-modal]');
    if (!modal) return;
    const body = modal.querySelector('[data-quickview-body]');
    const qs = window.quickviewStrings || {};
    let lastFocus = null;
    let currentHandle = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('overflow-hidden');
      const closeBtn = modal.querySelector('[data-quickview-close]');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
      if (body) body.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    async function load(handle) {
      if (!handle) return;
      currentHandle = handle;
      if (body) body.innerHTML = '<div class="qv-modal__loading">' + (qs.loading || 'Yükleniyor...') + '</div>';
      open();
      try {
        const res = await fetch('/products/' + encodeURIComponent(handle) + '?view=quick-view');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-quick-view]');
        if (!content) throw new Error('no content');
        if (currentHandle !== handle) return; // başka ürün açıldıysa iptal
        body.innerHTML = '';
        body.appendChild(content);
        wireVariants(body);
        syncFavToggles();
      } catch (err) {
        console.error('Quick view yüklenemedi', err);
        if (body) body.innerHTML = '<div class="qv-modal__loading">' + (qs.error || 'İçerik yüklenemedi.') + '</div>';
      }
    }

    // Modal içi varyant seçimi (product.js'in hafif kopyası, kaba scope)
    function wireVariants(scope) {
      const selector = scope.querySelector('[data-qv-variant-selector]');
      if (!selector) return;
      let variants = [];
      try { variants = JSON.parse(selector.querySelector('[data-qv-variants]').textContent); } catch (e) { return; }
      selector.addEventListener('change', (e) => {
        if (!e.target.classList.contains('product__option-input')) return;
        const opts = [];
        selector.querySelectorAll('.product__option').forEach((fs) => {
          const checked = fs.querySelector('input:checked');
          if (checked) opts.push(checked.value);
        });
        selector.querySelectorAll('[data-qv-option-selected]').forEach((span) => {
          const fs = span.closest('.product__option');
          const checked = fs && fs.querySelector('input:checked');
          if (checked) span.textContent = checked.value;
        });
        const v = variants.find((x) => opts.every((val, i) => x.options[i] === val));
        const idInput = scope.querySelector('[data-qv-variant-id]');
        const addBtn = scope.querySelector('[data-add-button]');
        const addLabel = scope.querySelector('[data-qv-add-label]');
        const priceBlock = scope.querySelector('[data-qv-price-block] .price');
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = qs.unavailable || 'Mevcut değil';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? (qs.add_to_cart || 'Sepete Ekle') : (qs.sold_out || 'Tükendi');
        if (priceBlock) {
          const cur = priceBlock.querySelector('.price__current');
          if (cur) cur.textContent = Theme.money(v.price);
        }
        const img = scope.querySelector('#QuickViewImage');
        if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src; img.removeAttribute('srcset'); }
      });
    }

    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-quick-view-open]');
      if (openBtn) { e.preventDefault(); load(openBtn.getAttribute('data-handle')); return; }
      if (e.target.closest('[data-quickview-close]')) { close(); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
    // Sepete eklenince modalı kapat (global cart form handler sepet çekmecesini açar)
    Theme.on('cart:updated', () => { if (!modal.hidden) close(); });
  }

  /* ----- İndirim kodu formu -----
     Shopify'ın desteklediği /discount/{kod} yönlendirmesiyle kodu sepete uygular
     ve /cart'a geri döner. Backend/Storefront API gerektirmez. */
  function initDiscountForms() {
    document.querySelectorAll('[data-discount-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = form.querySelector('[data-discount-input]');
        const code = (input && input.value || '').trim();
        if (!code) { if (input) input.focus(); return; }
        const btn = form.querySelector('[data-discount-apply]');
        if (btn) btn.classList.add('is-loading');
        window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
      });
    });
  }

  /* ----- Fiyat aralığı kaydırıcısı (koleksiyon filtresi) ----- */
  function initPriceSlider() {
    document.querySelectorAll('[data-price-slider]').forEach((slider) => {
      const rangeMin = slider.querySelector('[data-slider-min]');
      const rangeMax = slider.querySelector('[data-slider-max]');
      const fill = slider.querySelector('[data-slider-fill]');
      const max = parseInt(slider.getAttribute('data-max'), 10) || 0;
      const group = slider.closest('.filter-group__body') || document;
      const numMin = group.querySelector('[data-price-min]');
      const numMax = group.querySelector('[data-price-max]');
      if (!rangeMin || !rangeMax || max <= 0) return;

      const paint = () => {
        let lo = parseInt(rangeMin.value, 10);
        let hi = parseInt(rangeMax.value, 10);
        if (lo > hi) { const t = lo; lo = hi; hi = t; }
        fill.style.left = (lo / max * 100) + '%';
        fill.style.right = (100 - hi / max * 100) + '%';
      };

      // Number inputs -> slider
      const syncFromNumbers = () => {
        if (numMin) rangeMin.value = numMin.value === '' ? 0 : Math.min(parseInt(numMin.value, 10) || 0, max);
        if (numMax) rangeMax.value = numMax.value === '' ? max : Math.min(parseInt(numMax.value, 10) || max, max);
        paint();
      };

      rangeMin.addEventListener('input', () => {
        if (parseInt(rangeMin.value, 10) > parseInt(rangeMax.value, 10)) rangeMin.value = rangeMax.value;
        if (numMin) numMin.value = rangeMin.value;
        paint();
      });
      rangeMax.addEventListener('input', () => {
        if (parseInt(rangeMax.value, 10) < parseInt(rangeMin.value, 10)) rangeMax.value = rangeMin.value;
        if (numMax) numMax.value = (parseInt(rangeMax.value, 10) === max) ? '' : rangeMax.value;
        paint();
      });
      if (numMin) numMin.addEventListener('input', syncFromNumbers);
      if (numMax) numMax.addEventListener('input', syncFromNumbers);

      slider.hidden = false;
      syncFromNumbers();
    });
  }

  /* ----- Ödeme öncesi sözleşme onayı ----- */
  function initCartConsent() {
    function scopeOf(el) {
      return el.closest('[data-cart-footer], .cart-page__summary, form');
    }
    function findConsent(trigger) {
      var scope = scopeOf(trigger);
      return scope ? scope.querySelector('[data-cart-consent]') : null;
    }
    function apply(trigger) {
      var cb = findConsent(trigger);
      if (!cb) return;
      trigger.classList.toggle('is-consent-locked', !cb.checked);
      trigger.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
    }
    function applyAll() {
      document.querySelectorAll('[data-checkout-trigger]').forEach(apply);
    }
    document.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      var cb = e.target.closest('[data-cart-consent]');
      if (!cb) return;
      var scope = scopeOf(cb);
      if (!scope) return;
      scope.querySelectorAll('[data-checkout-trigger]').forEach(apply);
      var err = scope.querySelector('[data-cart-consent-error]');
      if (err && cb.checked) err.hidden = true;
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var trigger = e.target.closest('[data-checkout-trigger]');
      if (!trigger) return;
      var cb = findConsent(trigger);
      if (cb && !cb.checked) {
        e.preventDefault();
        var scope = scopeOf(trigger);
        var err = scope && scope.querySelector('[data-cart-consent-error]');
        if (err) err.hidden = false;
        cb.focus();
      }
    }, true);
    applyAll();
    if (window.Theme && Theme.on) Theme.on('cart:updated', applyAll);
  }

  /* ----- Mega menü ----- */
  function initMegaMenu() {
    document.querySelectorAll('[data-megamenu]').forEach((menu) => {
      const trigger = menu.querySelector('[data-megamenu-trigger]');
      const panel = menu.querySelector('[data-megamenu-panel]');
      if (!trigger || !panel) return;

      const open = () => {
        document.querySelectorAll('[data-megamenu-panel], [data-catdrop-panel]').forEach((other) => {
          if (other === panel || other.hidden) return;
          other.hidden = true;
          const owner = other.closest('[data-megamenu], [data-catdrop]');
          owner?.querySelector('[data-megamenu-trigger], [data-catdrop-trigger]')?.setAttribute('aria-expanded', 'false');
        });
        panel.hidden = false;
        panel.style.setProperty('--menu-available-height', Math.max(220, window.innerHeight - panel.getBoundingClientRect().top - 16) + 'px');
        trigger.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        panel.hidden ? open() : close();
      });

      // Sekmeler
      menu.querySelectorAll('[data-megamenu-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-megamenu-tab');
          menu.querySelectorAll('[data-megamenu-tab]').forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          menu.querySelectorAll('[data-megamenu-content]').forEach((c) => {
            c.classList.toggle('is-active', c.getAttribute('data-megamenu-content') === target);
          });
        });
      });

      document.addEventListener('click', (e) => {
        if (!menu.contains(e.target) && !panel.hidden) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.hidden) {
          close();
          trigger.focus();
        }
      });
    });
  }

  /* ----- Kategori şeridi: kaydırma ipucu (sağ kenar solması) ----- */
  function initScrollFade(el) {
    if (!el) return;
    const update = () => {
      // Kaydirilamiyorsa (masaustu) ya da sona gelindiyse solmayi kaldir
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
      el.classList.toggle('is-end', atEnd);
    };
    el.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  /* ----- Kategori seridi: masaustu kaydirma (oklar + tekerlek) -----
     Serit overflow-x:auto ama scrollbar gizli. Mobilde dokunmayla kayiyordu,
     masaustunde hicbir yolu yoktu -> sigmayan kategoriler erisilemiyordu. */
  function initCatStripOk() {
    const sarmal = document.querySelector('[data-catstrip-wrap]');
    if (!sarmal) return;
    const serit = sarmal.querySelector('.header__catstrip');
    const oklar = sarmal.querySelectorAll('[data-catstrip-ok]');
    if (!serit || !oklar.length) return;

    const guncelle = () => {
      const tasiyor = serit.scrollWidth > serit.clientWidth + 2;
      const sol = tasiyor && serit.scrollLeft > 4;
      const sag = tasiyor && serit.scrollLeft + serit.clientWidth < serit.scrollWidth - 4;
      oklar.forEach((o) => {
        const yon = Number(o.getAttribute('data-catstrip-ok'));
        o.hidden = yon < 0 ? !sol : !sag;
      });
      sarmal.classList.toggle('has-sol', sol);
      sarmal.classList.toggle('has-sag', sag);
    };

    oklar.forEach((o) => {
      o.addEventListener('click', () => {
        const yon = Number(o.getAttribute('data-catstrip-ok'));
        // Hareketi azalt ayari acikken animasyon yerine dogrudan atla
        const az = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        serit.scrollBy({ left: yon * Math.round(serit.clientWidth * 0.7),
                         behavior: az ? 'auto' : 'smooth' });
      });
    });

    // Dikey tekerlek hareketini yatay kaydirmaya cevir (yalnizca serit tasiyorsa)
    serit.addEventListener('wheel', (e) => {
      if (serit.scrollWidth <= serit.clientWidth) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      const once = serit.scrollLeft;
      serit.scrollLeft += e.deltaY;
      if (serit.scrollLeft !== once) e.preventDefault();
    }, { passive: false });

    serit.addEventListener('scroll', guncelle, { passive: true });
    window.addEventListener('resize', guncelle);
    guncelle();
  }

  function initCatStripFade() {
    // Ust kategori seridi + kategori sayfasindaki yana kayan alt kategori seridi
    initScrollFade(document.querySelector('.header__catstrip'));
    initCatStripOk();
    document.querySelectorAll('.subnav__grid').forEach(initScrollFade);
  }

  /* ----- Açıklama kısaltma: "Devamını oku" (kategori + marka hero) ----- */
  function initDescClamp() {
    document.querySelectorAll('[data-clamp-wrap]').forEach((wrap) => {
      const desc = wrap.querySelector('[data-clamp]');
      const btn = wrap.querySelector('[data-clamp-toggle]');
      const label = wrap.querySelector('[data-clamp-label]');
      if (!desc || !btn) return;

      var expanded = false; // kullanıcı açtıysa yeniden ölçüp kapatma

      // Butonu göster/gizle: KIRILGAN olmasın diye her seferinde clamp'i geri koyup
      // taşmayı yeniden ölçer. Tek seferlik ölçüm font/CSS gecikmesinde yanlış çıkıp
      // kısaltmayı kalıcı kaldırıyordu (masaüstünde clamp CSS'i yok -> otomatik tam metin).
      const evaluate = () => {
        if (expanded) return;
        desc.classList.add('is-clamped');
        const overflows = desc.scrollHeight > desc.clientHeight + 2;
        btn.hidden = !overflows;
        if (!overflows) desc.classList.remove('is-clamped');
      };
      evaluate();
      // Yükleme (font/görsel oturunca) ve yeniden boyutlandırmada tekrar ölç
      window.addEventListener('load', evaluate);
      window.addEventListener('resize', Theme.debounce(evaluate, 200));

      btn.addEventListener('click', () => {
        expanded = desc.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) {
          label.textContent = expanded
            ? (window.themeStrings && window.themeStrings.read_less) || 'Daha az göster'
            : (window.themeStrings && window.themeStrings.read_more) || 'Devamını oku';
        }
      });
    });
  }

  /* ----- Üst şerit: tıklayınca açılan alt kategori paneli ----- */
  function initCatDropdowns() {
    const drops = document.querySelectorAll('[data-catdrop]');
    if (!drops.length) return;

    const all = [];
    drops.forEach((drop) => {
      const trigger = drop.querySelector('[data-catdrop-trigger]');
      const panel = drop.querySelector('[data-catdrop-panel]');
      if (!trigger || !panel) return;

      const close = () => {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };
      // Panel position:fixed (seridin overflow kirpmasindan kacmak icin) ->
      // konumu burada, tetikleyicinin ekrandaki yerine gore hesaplaniyor.
      const place = () => {
        const t = trigger.getBoundingClientRect();
        panel.style.top = Math.round(t.bottom + 8) + 'px';
        panel.style.setProperty('--menu-available-height', Math.max(120, window.innerHeight - t.bottom - 24) + 'px');
        if (window.innerWidth >= 750) {
          const w = panel.offsetWidth;
          let left = t.left;
          if (left + w > window.innerWidth - 8) left = window.innerWidth - w - 8;
          if (left < 8) left = 8;
          panel.style.left = Math.round(left) + 'px';
        }
      };
      const open = () => {
        document.querySelectorAll('[data-megamenu-panel], [data-catdrop-panel]').forEach((other) => {
          if (other === panel || other.hidden) return;
          other.hidden = true;
          const owner = other.closest('[data-megamenu], [data-catdrop]');
          owner?.querySelector('[data-megamenu-trigger], [data-catdrop-trigger]')?.setAttribute('aria-expanded', 'false');
        });
        all.forEach((o) => { if (o !== close) o(); }); // aynı anda tek panel
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        place();
      };
      all.push(close);

      // Sayfa kayinca header kuculuyor -> panel tetikleyiciden kopmasin, kapat
      window.addEventListener('scroll', () => { if (!panel.hidden) close(); }, { passive: true });
      window.addEventListener('resize', () => { if (!panel.hidden) place(); });

      trigger.addEventListener('click', (e) => {
        // Mobil/tablet: panel yok, doğrudan kategoriye git (CSS ile aynı eşik).
        // Dokunmatikte panel fazladan dokunuş; kategori sayfasının üstünde
        // zaten görselli alt kategori kartları var.
        if (window.innerWidth < 990) return;
        // Ctrl/Cmd/Shift + tık ve orta tık: linke dokunma, yeni sekmede açılsın
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        e.stopPropagation();
        panel.hidden ? open() : close();
      });

      document.addEventListener('click', (e) => {
        if (!drop.contains(e.target) && !panel.hidden) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.hidden) {
          close();
          trigger.focus();
        }
      });
    });
  }

  /* ----- Kaydırınca küçülen sticky header ----- */
  function initStickyHeader() {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.classList.toggle('is-scrolled', window.scrollY > 60);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----- Mobil alt gezinme çubuğu ----- */
  // "Ara" düğmesi: sayfa başına kaydırır ve arama kutusuna odaklanır.
  function initBottomNav() {
    document.querySelectorAll('[data-bottom-search]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = document.querySelector('[data-predictive-input]');
        // focus() KULLANICI HAREKETININ ICINDE cagrilmali, setTimeout icinde DEGIL:
        // mobil tarayicilar klavyeyi sadece gesture zincirinde acar. Eskiden
        // setTimeout(320) icindeydi -> odak gidiyor ama klavye acilmiyordu.
        if (input) input.focus();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  /* ----- Footer akordeon (yalnızca mobil) ----- */
  function initFooterAccordion() {
    const toggles = document.querySelectorAll('[data-footer-toggle]');
    if (!toggles.length) return;
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    toggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!isMobile()) return;
        const col = btn.closest('.footer__col');
        if (!col) return;
        const open = col.hasAttribute('data-open');
        if (open) {
          col.removeAttribute('data-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          col.setAttribute('data-open', '');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ----- KVKK / çerez bandı ----- */
  function initCookieBanner() {
    const banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;

    // Shopify Customer Privacy API'sine izni bildirir (GA/Meta/Shopify analitiği bunu dinler).
    function setConsent(granted) {
      try {
        if (!window.Shopify || !window.Shopify.loadFeatures) return;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
          if (err || !window.Shopify.customerPrivacy) return;
          window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted
          }, () => {});
        });
      } catch (e) {}
    }

    let saved = null;
    try {
      saved = localStorage.getItem('cookie-consent');
      // eski sürümle uyum: 'cookie-accepted' = '1' -> kabul
      if (!saved && localStorage.getItem('cookie-accepted') === '1') saved = 'accepted';
    } catch (e) {}

    if (saved === 'accepted' || saved === 'rejected') {
      setConsent(saved === 'accepted');
      return;
    }

    banner.hidden = false;

    function decide(granted) {
      banner.hidden = true;
      try { localStorage.setItem('cookie-consent', granted ? 'accepted' : 'rejected'); } catch (e) {}
      setConsent(granted);
    }

    const accept = banner.querySelector('[data-cookie-accept]');
    const reject = banner.querySelector('[data-cookie-reject]');
    if (accept) accept.addEventListener('click', () => decide(true));
    if (reject) reject.addEventListener('click', () => decide(false));
  }

  /* ----- Başlatma ----- */
  function init() {
    initAnnouncementDismiss();
    initAnnouncementRotator();
    initDrawers();
    initMegaMenu();
    initCatDropdowns();
    initCatStripFade();
    initDescClamp();
    initCartForms();
    initCartPage();
    initCartActions();
    initDiscountForms();
    initPriceSlider();
    initCartConsent();
    initFavorites();
    initCompare();
    initQuickView();
    initStickyHeader();
    initBottomNav();
    initFooterAccordion();
    initCookieBanner();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Theme = Theme;
})();
